// extracted by mini-css-extract-plugin
export var bubble = "_48-0";
export var container = "_48-f";
export var contrastBorder = "_48-g";
export var greyOut = "_48-2";
export var initialsColor0 = "_48-3";
export var initialsColor1 = "_48-4";
export var initialsColor10 = "_48-d";
export var initialsColor11 = "_48-e";
export var initialsColor2 = "_48-5";
export var initialsColor3 = "_48-6";
export var initialsColor4 = "_48-7";
export var initialsColor5 = "_48-8";
export var initialsColor6 = "_48-9";
export var initialsColor7 = "_48-a";
export var initialsColor8 = "_48-b";
export var initialsColor9 = "_48-c";
export var initialsWrapper = "_48-1";
export var large = "_48-l";
export var medium = "_48-k";
export var mediumSmall = "_48-j";
export var mediumSmallMedium = "_48-o";
export var micro = "_48-h";
export var small = "_48-i";
export var tiny = "_48-n";
export var xTiny = "_48-m";